import { ISiteLoginParams } from '~src/authentication/serverApi/types/ISiteLoginParams';
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetSessionInfoResult } from '~src/sessionManagement/serverApi/requests/GetSessionInfoRequest';

export class ClientCertificateLoginRequest extends Request<ISiteLoginParams, IGetSessionInfoResult> {
  constructor(params: ISiteLoginParams) {
    super('auth/clientCertificateLogin', params);
  }
}
